import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, Button, CircularProgress, FormHelperText, TextField } from '@mui/material';
import { ChangeEvent, FormEvent } from 'react';
import { MAX_RANGE_DAYS, validateRange } from './rangeUtils';
import { RecalculateParams, UUID_RE, isComplete } from './urlParams';

const uuidError = (v: string) => (v && !UUID_RE.test(v) ? 'not a UUID' : undefined);

interface RecalculateFormProps {
  value: RecalculateParams;
  onChange: (next: RecalculateParams) => void;
  onSubmit: () => void;
  onLoadData: () => void;
  loading: boolean;
  loadingData: boolean;
}

export const RecalculateForm = ({ value, onChange, onSubmit, onLoadData, loading, loadingData }: RecalculateFormProps) => {
  const rangeError = validateRange(value.from, value.to);
  const set = (key: keyof RecalculateParams) => (e: ChangeEvent<HTMLInputElement>) => onChange({ ...value, [key]: e.target.value.trim() });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (isComplete(value)) onSubmit();
  };
  const complete = isComplete(value);

  return (
    <form onSubmit={submit}>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 2fr 1fr 1fr auto auto' }, gap: 2, alignItems: 'start' }}>
        <TextField label="Company UUID" value={value.companyUuid} onChange={set('companyUuid')} error={!!uuidError(value.companyUuid)} helperText={uuidError(value.companyUuid) ?? ' '} size="small" />
        <TextField label="User profile UUID" value={value.userProfileUuid} onChange={set('userProfileUuid')} error={!!uuidError(value.userProfileUuid)} helperText={uuidError(value.userProfileUuid) ?? ' '} size="small" />
        <TextField label="From" type="date" value={value.from} onChange={set('from')} InputLabelProps={{ shrink: true }} size="small" helperText=" " />
        <TextField label="To" type="date" value={value.to} onChange={set('to')} InputLabelProps={{ shrink: true }} size="small" helperText=" " />
        <Button variant="outlined" disabled={loadingData || !complete} startIcon={loadingData ? <CircularProgress size={16} /> : <RefreshIcon />} sx={{ mt: 0.25 }} onClick={onLoadData}>
          Load data
        </Button>
        <Button type="submit" variant="contained" disabled={loading || !complete} startIcon={loading ? <CircularProgress size={16} /> : <PlayArrowIcon />} sx={{ mt: 0.25 }}>
          Run
        </Button>
      </Box>
      <FormHelperText error={!!rangeError}>{rangeError ?? `Up to ${MAX_RANGE_DAYS} days inclusive. Synchronous. Fetched sources are snapshotted upstream and the run's results are written to the employee's stored summaries.`}</FormHelperText>
    </form>
  );
};

export default RecalculateForm;
